
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { createSmsAccount } from '@/api/product/smsManage'

@Component({
  name: 'addAccount',
  components: {}
})
export default class extends Vue {
  private infoForm: any = {
    account: '',
    password: '',
    status: null,
    price: ''
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private back() {
    this.$emit('close', false)
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          createSmsAccount(this.infoForm).then(() => {
            this.$message({
              message: 'Create successful!',
              type: 'success'
            })
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  mounted() {}
}
